"use strict";
// https://www.countries-ofthe-world.com/list-of-country-calling-codes.html
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAP_REGIONID_2_SUBREGION = exports.ALL_COUNTRIES = void 0;
exports.ALL_COUNTRIES = {
    DE: {
        country_code: 'DE',
        timezones: ['Europe/Berlin'],
        preDial: '+49',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'Deutschland',
        mobilePreDials: [
            '151',
            '152',
            '155',
            '157',
            '159',
            '160',
            '162',
            '163',
            '170',
            '171',
            '172',
            '173',
            '174',
            '175',
            '176',
            '177',
            '178',
            '179'
        ],
        subregions: [
            {
                country_code: "DE",
                subdivision_name: "Baden-Württemberg",
                code: "DE-BW"
            },
            {
                country_code: "DE",
                subdivision_name: "Bayern",
                code: "DE-BY"
            },
            {
                country_code: "DE",
                subdivision_name: "Berlin",
                code: "DE-BE"
            },
            {
                country_code: "DE",
                subdivision_name: "Brandenburg",
                code: "DE-BB"
            },
            {
                country_code: "DE",
                subdivision_name: "Bremen",
                code: "DE-HB"
            },
            {
                country_code: "DE",
                subdivision_name: "Hamburg",
                code: "DE-HH"
            },
            {
                country_code: "DE",
                subdivision_name: "Hessen",
                code: "DE-HE"
            },
            {
                country_code: "DE",
                subdivision_name: "Mecklenburg-Vorpommern",
                code: "DE-MV"
            },
            {
                country_code: "DE",
                subdivision_name: "Niedersachsen",
                code: "DE-NI"
            },
            {
                country_code: "DE",
                subdivision_name: "Nordrhein-Westfalen",
                code: "DE-NW"
            },
            {
                country_code: "DE",
                subdivision_name: "Rheinland-Pfalz",
                code: "DE-RP"
            },
            {
                country_code: "DE",
                subdivision_name: "Saarland",
                code: "DE-SL"
            },
            {
                country_code: "DE",
                subdivision_name: "Sachsen",
                code: "DE-SN"
            },
            {
                country_code: "DE",
                subdivision_name: "Sachsen-Anhalt",
                code: "DE-ST"
            },
            {
                country_code: "DE",
                subdivision_name: "Schleswig-Holstein",
                code: "DE-SH"
            },
            {
                country_code: "DE",
                subdivision_name: "Thuringen",
                code: "DE-TH"
            }
        ],
        currency: 'EUR',
    },
    AT: {
        country_code: 'AT',
        timezones: ['Europe/Vienna'],
        preDial: '+43',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'Österreich',
        mobilePreDials: [
            '6'
        ],
        subregions: [
            {
                country_code: "AT",
                subdivision_name: "Burgenland",
                code: "AT-1"
            },
            {
                country_code: "AT",
                subdivision_name: "Karnten",
                code: "AT-2"
            },
            {
                country_code: "AT",
                subdivision_name: "Niederosterreich",
                code: "AT-3"
            },
            {
                country_code: "AT",
                subdivision_name: "Oberosterreich",
                code: "AT-4"
            },
            {
                country_code: "AT",
                subdivision_name: "Salzburg",
                code: "AT-5"
            },
            {
                country_code: "AT",
                subdivision_name: "Steiermark",
                code: "AT-6"
            },
            {
                country_code: "AT",
                subdivision_name: "Tirol",
                code: "AT-7"
            },
            {
                country_code: "AT",
                subdivision_name: "Vorarlberg",
                code: "AT-8"
            },
            {
                country_code: "AT",
                subdivision_name: "Wien",
                code: "AT-9"
            }
        ],
        currency: 'EUR'
    },
    LI: {
        preDial: '+423',
        internationalPreDial: '00',
        timezones: ['Europe/Vaduz'],
        country_code: 'LI',
        name: 'Liechtenstein',
        mobilePreDials: [
            '7'
        ],
        subregions: [
            {
                country_code: "LI",
                subdivision_name: "Balzers",
                code: "LI-01"
            },
            {
                country_code: "LI",
                subdivision_name: "Eschen",
                code: "LI-02"
            },
            {
                country_code: "LI",
                subdivision_name: "Gamprin",
                code: "LI-03"
            },
            {
                country_code: "LI",
                subdivision_name: "Mauren",
                code: "LI-04"
            },
            {
                country_code: "LI",
                subdivision_name: "Planken",
                code: "LI-05"
            },
            {
                country_code: "LI",
                subdivision_name: "Ruggell",
                code: "LI-06"
            },
            {
                country_code: "LI",
                subdivision_name: "Schaan",
                code: "LI-07"
            },
            {
                country_code: "LI",
                subdivision_name: "Triesen",
                code: "LI-09"
            },
            {
                country_code: "LI",
                subdivision_name: "Triesenberg",
                code: "LI-10"
            },
            {
                country_code: "LI",
                subdivision_name: "Vaduz",
                code: "LI-11"
            }
        ],
        currency: 'EUR'
    },
    CH: {
        country_code: 'CH',
        timezones: ['Europe/Zurich'],
        preDial: '+41',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'Schweiz',
        mobilePreDials: [
            '74',
            '75',
            '76',
            '77',
            '78',
            '79'
        ],
        subregions: [
            {
                country_code: "CH",
                subdivision_name: "Aargau",
                code: "CH-AG"
            },
            {
                country_code: "CH",
                subdivision_name: "Appenzell Ausserrhoden",
                code: "CH-AR"
            },
            {
                country_code: "CH",
                subdivision_name: "Appenzell Innerrhoden",
                code: "CH-AI"
            },
            {
                country_code: "CH",
                subdivision_name: "Basel-Land",
                code: "CH-BL"
            },
            {
                country_code: "CH",
                subdivision_name: "Basel-Stadt",
                code: "CH-BS"
            },
            {
                country_code: "CH",
                subdivision_name: "Bern",
                code: "CH-BE"
            },
            {
                country_code: "CH",
                subdivision_name: "Fribourg",
                code: "CH-FR"
            },
            {
                country_code: "CH",
                subdivision_name: "Geneve",
                code: "CH-GE"
            },
            {
                country_code: "CH",
                subdivision_name: "Glarus",
                code: "CH-GL"
            },
            {
                country_code: "CH",
                subdivision_name: "Graubunden",
                code: "CH-GR"
            },
            {
                country_code: "CH",
                subdivision_name: "Jura",
                code: "CH-JU"
            },
            {
                country_code: "CH",
                subdivision_name: "Luzern",
                code: "CH-LU"
            },
            {
                country_code: "CH",
                subdivision_name: "Neuchatel",
                code: "CH-NE"
            },
            {
                country_code: "CH",
                subdivision_name: "Nidwalden",
                code: "CH-NW"
            },
            {
                country_code: "CH",
                subdivision_name: "Obwalden",
                code: "CH-OW"
            },
            {
                country_code: "CH",
                subdivision_name: "Sankt Gallen",
                code: "CH-SG"
            },
            {
                country_code: "CH",
                subdivision_name: "Schaffhausen",
                code: "CH-SH"
            },
            {
                country_code: "CH",
                subdivision_name: "Schwyz",
                code: "CH-SZ"
            },
            {
                country_code: "CH",
                subdivision_name: "Solothurn",
                code: "CH-SO"
            },
            {
                country_code: "CH",
                subdivision_name: "Thurgau",
                code: "CH-TG"
            },
            {
                country_code: "CH",
                subdivision_name: "Ticino",
                code: "CH-TI"
            },
            {
                country_code: "CH",
                subdivision_name: "Uri",
                code: "CH-UR"
            },
            {
                country_code: "CH",
                subdivision_name: "Valais",
                code: "CH-VS"
            },
            {
                country_code: "CH",
                subdivision_name: "Vaud",
                code: "CH-VD"
            },
            {
                country_code: "CH",
                subdivision_name: "Zug",
                code: "CH-ZG"
            },
            {
                country_code: "CH",
                subdivision_name: "Zurich",
                code: "CH-ZH"
            },
            {
                country_code: "CI",
                subdivision_name: "Abidjan",
                code: "CI-AB"
            }
        ],
        currency: 'CHF'
    },
    FR: {
        country_code: 'FR',
        timezones: ['Europe/Paris'],
        preDial: '+33',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'France',
        mobilePreDials: [
            '6'
        ],
        subregions: [
            {
                country_code: "FR",
                subdivision_name: "Auvergne-Rhone-Alpes",
                code: "FR-ARA"
            },
            {
                country_code: "FR",
                subdivision_name: "Bourgogne-Franche-Comte",
                code: "FR-BFC"
            },
            {
                country_code: "FR",
                subdivision_name: "Bretagne",
                code: "FR-BRE"
            },
            {
                country_code: "FR",
                subdivision_name: "Centre-Val de Loire",
                code: "FR-CVL"
            },
            {
                country_code: "FR",
                subdivision_name: "Corse",
                code: "FR-20R"
            },
            {
                country_code: "FR",
                subdivision_name: "Grand-Est",
                code: "FR-GES"
            },
            {
                country_code: "FR",
                subdivision_name: "Hauts-de-France",
                code: "FR-HDF"
            },
            {
                country_code: "FR",
                subdivision_name: "Ile-de-France",
                code: "FR-IDF"
            },
            {
                country_code: "FR",
                subdivision_name: "Normandie",
                code: "FR-NOR"
            },
            {
                country_code: "FR",
                subdivision_name: "Nouvelle-Aquitaine",
                code: "FR-NAQ"
            },
            {
                country_code: "FR",
                subdivision_name: "Occitanie",
                code: "FR-OCC"
            },
            {
                country_code: "FR",
                subdivision_name: "Pays-de-la-Loire",
                code: "FR-PDL"
            },
            {
                country_code: "FR",
                subdivision_name: "Provence-Alpes-Cote-d'Azur",
                code: "FR-PAC"
            }
        ],
        currency: 'EUR'
    },
    IT: {
        country_code: 'IT',
        timezones: ['Europe/Rome'],
        preDial: '+39',
        internationalPreDial: '00',
        name: 'Italia',
        mobilePreDials: [
            '310',
            '31100',
            '31101',
            '31105',
            '313',
            '319',
            '320',
            '322',
            '323',
            '324',
            '327',
            '328',
            '329',
            '33',
            '34',
            '3505',
            '3510',
            '3512',
            '360',
            '361',
            '362',
            '363',
            '366',
            '368',
            '370',
            '3710',
            '3711',
            '373',
            '377',
            '380',
            '381',
            '382',
            '383',
            '385',
            '388',
            '389',
            '390',
            '391',
            '392',
            '393',
            '397'
        ],
        subregions: [
            {
                country_code: "IT",
                subdivision_name: "Abruzzo",
                code: "IT-65"
            },
            {
                country_code: "IT",
                subdivision_name: "Basilicata",
                code: "IT-77"
            },
            {
                country_code: "IT",
                subdivision_name: "Calabria",
                code: "IT-78"
            },
            {
                country_code: "IT",
                subdivision_name: "Campania",
                code: "IT-72"
            },
            {
                country_code: "IT",
                subdivision_name: "Emilia-Romagna",
                code: "IT-45"
            },
            {
                country_code: "IT",
                subdivision_name: "Friuli-Venezia Giulia",
                code: "IT-36"
            },
            {
                country_code: "IT",
                subdivision_name: "Lazio",
                code: "IT-62"
            },
            {
                country_code: "IT",
                subdivision_name: "Liguria",
                code: "IT-42"
            },
            {
                country_code: "IT",
                subdivision_name: "Lombardia",
                code: "IT-25"
            },
            {
                country_code: "IT",
                subdivision_name: "Marche",
                code: "IT-57"
            },
            {
                country_code: "IT",
                subdivision_name: "Molise",
                code: "IT-67"
            },
            {
                country_code: "IT",
                subdivision_name: "Piemonte",
                code: "IT-21"
            },
            {
                country_code: "IT",
                subdivision_name: "Puglia",
                code: "IT-75"
            },
            {
                country_code: "IT",
                subdivision_name: "Sardegna",
                code: "IT-88"
            },
            {
                country_code: "IT",
                subdivision_name: "Sicilia",
                code: "IT-82"
            },
            {
                country_code: "IT",
                subdivision_name: "Toscana",
                code: "IT-52"
            },
            {
                country_code: "IT",
                subdivision_name: "Trentino-Alto Adige",
                code: "IT-32"
            },
            {
                country_code: "IT",
                subdivision_name: "Umbria",
                code: "IT-55"
            },
            {
                country_code: "IT",
                subdivision_name: "Valle d'Aosta",
                code: "IT-23"
            },
            {
                country_code: "IT",
                subdivision_name: "Veneto",
                code: "IT-34"
            }
        ],
        currency: 'EUR'
    },
    ES: {
        country_code: 'ES',
        timezones: ['Europe/Madrid'],
        preDial: '+34',
        internationalPreDial: '00',
        name: 'España',
        mobilePreDials: [
            '6',
            '7'
        ],
        subregions: [
            {
                country_code: "ES",
                subdivision_name: "Andalucia",
                code: "ES-AN"
            },
            {
                country_code: "ES",
                subdivision_name: "Aragon",
                code: "ES-AR"
            },
            {
                country_code: "ES",
                subdivision_name: "Asturias, Principado de",
                code: "ES-AS"
            },
            {
                country_code: "ES",
                subdivision_name: "Canarias",
                code: "ES-CN"
            },
            {
                country_code: "ES",
                subdivision_name: "Cantabria",
                code: "ES-CB"
            },
            {
                country_code: "ES",
                subdivision_name: "Castilla y Leon",
                code: "ES-CL"
            },
            {
                country_code: "ES",
                subdivision_name: "Castilla-La Mancha",
                code: "ES-CM"
            },
            {
                country_code: "ES",
                subdivision_name: "Catalunya",
                code: "ES-CT"
            },
            {
                country_code: "ES",
                subdivision_name: "Ceuta",
                code: "ES-CE"
            },
            {
                country_code: "ES",
                subdivision_name: "Extremadura",
                code: "ES-EX"
            },
            {
                country_code: "ES",
                subdivision_name: "Galicia",
                code: "ES-GA"
            },
            {
                country_code: "ES",
                subdivision_name: "Illes Balears",
                code: "ES-IB"
            },
            {
                country_code: "ES",
                subdivision_name: "La Rioja",
                code: "ES-RI"
            },
            {
                country_code: "ES",
                subdivision_name: "Madrid, Comunidad de",
                code: "ES-MD"
            },
            {
                country_code: "ES",
                subdivision_name: "Melilla",
                code: "ES-ML"
            },
            {
                country_code: "ES",
                subdivision_name: "Murcia, Region de",
                code: "ES-MC"
            },
            {
                country_code: "ES",
                subdivision_name: "Navarra, Comunidad Foral de",
                code: "ES-NC"
            },
            {
                country_code: "ES",
                subdivision_name: "Pais Vasco",
                code: "ES-PV"
            },
            {
                country_code: "ES",
                subdivision_name: "Valenciana, Comunidad",
                code: "ES-VC"
            }
        ],
        currency: 'EUR'
    },
    NL: {
        country_code: 'NL',
        timezones: ['Europe/Amsterdam'],
        preDial: '+31',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'Nederland',
        mobilePreDials: [
            '6'
        ],
        subregions: [
            {
                country_code: "NL",
                subdivision_name: "Drenthe",
                code: "NL-DR"
            },
            {
                country_code: "NL",
                subdivision_name: "Flevoland",
                code: "NL-FL"
            },
            {
                country_code: "NL",
                subdivision_name: "Fryslan",
                code: "NL-FR"
            },
            {
                country_code: "NL",
                subdivision_name: "Gelderland",
                code: "NL-GE"
            },
            {
                country_code: "NL",
                subdivision_name: "Groningen",
                code: "NL-GR"
            },
            {
                country_code: "NL",
                subdivision_name: "Limburg",
                code: "NL-LI"
            },
            {
                country_code: "NL",
                subdivision_name: "Noord-Brabant",
                code: "NL-NB"
            },
            {
                country_code: "NL",
                subdivision_name: "Noord-Holland",
                code: "NL-NH"
            },
            {
                country_code: "NL",
                subdivision_name: "Overijssel",
                code: "NL-OV"
            },
            {
                country_code: "NL",
                subdivision_name: "Utrecht",
                code: "NL-UT"
            },
            {
                country_code: "NL",
                subdivision_name: "Zeeland",
                code: "NL-ZE"
            },
            {
                country_code: "NL",
                subdivision_name: "Zuid-Holland",
                code: "NL-ZH"
            }
        ],
        currency: 'EUR'
    },
    BE: {
        country_code: 'BE',
        timezones: ['Europe/Brussels'],
        preDial: '+32',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'België',
        mobilePreDials: [
            '475',
            '476',
            '477',
            '478',
            '479',
            '494',
            '495',
            '496',
            '497',
            '498',
            '499',
            '484',
            '485',
            '486'
        ],
        subregions: [
            {
                country_code: "BE",
                subdivision_name: "Antwerpen",
                code: "BE-VAN"
            },
            {
                country_code: "BE",
                subdivision_name: "Brabant wallon",
                code: "BE-WBR"
            },
            {
                country_code: "BE",
                subdivision_name: "Brussels Hoofdstedelijk Gewest",
                code: "BE-BRU"
            },
            {
                country_code: "BE",
                subdivision_name: "Hainaut",
                code: "BE-WHT"
            },
            {
                country_code: "BE",
                subdivision_name: "Liege",
                code: "BE-WLG"
            },
            {
                country_code: "BE",
                subdivision_name: "Limburg",
                code: "BE-VLI"
            },
            {
                country_code: "BE",
                subdivision_name: "Luxembourg",
                code: "BE-WLX"
            },
            {
                country_code: "BE",
                subdivision_name: "Namur",
                code: "BE-WNA"
            },
            {
                country_code: "BE",
                subdivision_name: "Oost-Vlaanderen",
                code: "BE-VOV"
            },
            {
                country_code: "BE",
                subdivision_name: "Vlaams-Brabant",
                code: "BE-VBR"
            },
            {
                country_code: "BE",
                subdivision_name: "West-Vlaanderen",
                code: "BE-VWV"
            },
            {
                country_code: "BF",
                subdivision_name: "Bam",
                code: "BF-BAM"
            }
        ],
        currency: 'EUR'
    },
    DK: {
        country_code: 'DK',
        timezones: ['Europe/Copenhagen'],
        preDial: '+45',
        internationalPreDial: '00',
        name: 'Danmark',
        mobilePreDials: [
            '2',
            '30',
            '31',
            '40',
            '41',
            '42',
            '50',
            '51',
            '52',
            '53',
            '60',
            '61',
            '71',
            '81'
        ],
        subregions: [
            {
                country_code: "DK",
                subdivision_name: "Hovedstaden",
                code: "DK-84"
            },
            {
                country_code: "DK",
                subdivision_name: "Midtjylland",
                code: "DK-82"
            },
            {
                country_code: "DK",
                subdivision_name: "Nordjylland",
                code: "DK-81"
            },
            {
                country_code: "DK",
                subdivision_name: "Sjaelland",
                code: "DK-85"
            },
            {
                country_code: "DK",
                subdivision_name: "Syddanmark",
                code: "DK-83"
            }
        ],
        currency: 'DKK'
    },
    SE: {
        country_code: 'SE',
        timezones: ['Europe/Stockholm'],
        preDial: '+46',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'Sverige',
        mobilePreDials: [
            '70',
            '710',
            '72',
            '7300',
            '7301',
            '7302',
            '7303',
            '7304',
            '7305',
            '7306',
            '7307',
            '7308',
            '7309',
            '7310',
            '7311',
            '7312',
            '7313',
            '7314',
            '7315',
            '7316',
            '73170',
            '73171',
            '73172',
            '73173',
            '73174',
            '73175',
            '73176',
            '73177',
            '73178',
            '73179',
            '7318',
            '7319',
            '7320',
            '7321',
            '7322',
            '7323',
            '7324',
            '7325',
            '7326',
            '7327',
            '7328',
            '7329',
            '733',
            '7340',
            '7341',
            '7342',
            '7343',
            '7344',
            '7345',
            '7346',
            '7347',
            '7349',
            '7349',
            '735',
            '736',
            '737',
            '738',
            '739',
            '76',
            '79'
        ],
        subregions: [
            {
                country_code: "SE",
                subdivision_name: "Blekinge lan",
                code: "SE-K"
            },
            {
                country_code: "SE",
                subdivision_name: "Dalarnas lan",
                code: "SE-W"
            },
            {
                country_code: "SE",
                subdivision_name: "Gavleborgs lan",
                code: "SE-X"
            },
            {
                country_code: "SE",
                subdivision_name: "Gotlands lan",
                code: "SE-I"
            },
            {
                country_code: "SE",
                subdivision_name: "Hallands lan",
                code: "SE-N"
            },
            {
                country_code: "SE",
                subdivision_name: "Jamtlands lan",
                code: "SE-Z"
            },
            {
                country_code: "SE",
                subdivision_name: "Jonkopings lan",
                code: "SE-F"
            },
            {
                country_code: "SE",
                subdivision_name: "Kalmar lan",
                code: "SE-H"
            },
            {
                country_code: "SE",
                subdivision_name: "Kronobergs lan",
                code: "SE-G"
            },
            {
                country_code: "SE",
                subdivision_name: "Norrbottens lan",
                code: "SE-BD"
            },
            {
                country_code: "SE",
                subdivision_name: "Orebro lan",
                code: "SE-T"
            },
            {
                country_code: "SE",
                subdivision_name: "Ostergotlands lan",
                code: "SE-E"
            },
            {
                country_code: "SE",
                subdivision_name: "Skane lan",
                code: "SE-M"
            },
            {
                country_code: "SE",
                subdivision_name: "Sodermanlands lan",
                code: "SE-D"
            },
            {
                country_code: "SE",
                subdivision_name: "Stockholms lan",
                code: "SE-AB"
            },
            {
                country_code: "SE",
                subdivision_name: "Uppsala lan",
                code: "SE-C"
            },
            {
                country_code: "SE",
                subdivision_name: "Varmlands lan",
                code: "SE-S"
            },
            {
                country_code: "SE",
                subdivision_name: "Vasterbottens lan",
                code: "SE-AC"
            },
            {
                country_code: "SE",
                subdivision_name: "Vasternorrlands lan",
                code: "SE-Y"
            },
            {
                country_code: "SE",
                subdivision_name: "Vastmanlands lan",
                code: "SE-U"
            },
            {
                country_code: "SE",
                subdivision_name: "Vastra Gotalands lan",
                code: "SE-O"
            }
        ],
        currency: 'SEK'
    },
    LU: {
        country_code: 'LU',
        timezones: ['Europe/Luxembourg'],
        preDial: '+352',
        internationalPreDial: '00',
        name: 'Luxemburg',
        mobilePreDials: [
            '620',
            '628',
            '661',
            '668',
            '691',
            '698'
        ],
        subregions: [
            {
                country_code: "LU",
                subdivision_name: "Capellen",
                code: "LU-CA"
            },
            {
                country_code: "LU",
                subdivision_name: "Clervaux",
                code: "LU-CL"
            },
            {
                country_code: "LU",
                subdivision_name: "Diekirch",
                code: "LU-DI"
            },
            {
                country_code: "LU",
                subdivision_name: "Echternach",
                code: "LU-EC"
            },
            {
                country_code: "LU",
                subdivision_name: "Esch-sur-Alzette",
                code: "LU-ES"
            },
            {
                country_code: "LU",
                subdivision_name: "Grevenmacher",
                code: "LU-GR"
            },
            {
                country_code: "LU",
                subdivision_name: "Luxembourg",
                code: "LU-LU"
            },
            {
                country_code: "LU",
                subdivision_name: "Mersch",
                code: "LU-ME"
            },
            {
                country_code: "LU",
                subdivision_name: "Redange",
                code: "LU-RD"
            },
            {
                country_code: "LU",
                subdivision_name: "Remich",
                code: "LU-RM"
            },
            {
                country_code: "LU",
                subdivision_name: "Vianden",
                code: "LU-VD"
            },
            {
                country_code: "LU",
                subdivision_name: "Wiltz",
                code: "LU-WI"
            }
        ],
        currency: 'EUR'
    },
    GB: {
        country_code: 'GB',
        timezones: ['Europe/London'],
        preDial: '+44',
        nationalPreDial: '0',
        internationalPreDial: '00',
        name: 'Great Britain',
        mobilePreDials: [
            '71',
            '72',
            '73',
            '74',
            '75',
            '7624',
            '77',
            '78',
            '79'
        ],
        subregions: [
            {
                country_code: "GB",
                subdivision_name: "England",
                code: "GB-ENG"
            },
            {
                country_code: "GB",
                subdivision_name: "Northern Ireland",
                code: "GB-NIR"
            },
            {
                country_code: "GB",
                subdivision_name: "Scotland",
                code: "GB-SCT"
            },
            {
                country_code: "GB",
                subdivision_name: "Wales",
                code: "GB-WLS"
            }
        ],
        currency: 'GBP'
    },
    IE: {
        country_code: 'IE',
        timezones: ['Europe/Dublin'],
        name: 'Republic of Ireland',
        preDial: '+353',
        nationalPreDial: '0',
        internationalPreDial: '00',
        mobilePreDials: [
            '8'
        ],
        subregions: [
            {
                country_code: "IE",
                subdivision_name: "Carlow",
                code: "IE-CW"
            },
            {
                country_code: "IE",
                subdivision_name: "Cavan",
                code: "IE-CN"
            },
            {
                country_code: "IE",
                subdivision_name: "Clare",
                code: "IE-CE"
            },
            {
                country_code: "IE",
                subdivision_name: "Cork",
                code: "IE-CO"
            },
            {
                country_code: "IE",
                subdivision_name: "Donegal",
                code: "IE-DL"
            },
            {
                country_code: "IE",
                subdivision_name: "Dublin",
                code: "IE-D"
            },
            {
                country_code: "IE",
                subdivision_name: "Galway",
                code: "IE-G"
            },
            {
                country_code: "IE",
                subdivision_name: "Kerry",
                code: "IE-KY"
            },
            {
                country_code: "IE",
                subdivision_name: "Kildare",
                code: "IE-KE"
            },
            {
                country_code: "IE",
                subdivision_name: "Kilkenny",
                code: "IE-KK"
            },
            {
                country_code: "IE",
                subdivision_name: "Laois",
                code: "IE-LS"
            },
            {
                country_code: "IE",
                subdivision_name: "Leitrim",
                code: "IE-LM"
            },
            {
                country_code: "IE",
                subdivision_name: "Limerick",
                code: "IE-LK"
            },
            {
                country_code: "IE",
                subdivision_name: "Longford",
                code: "IE-LD"
            },
            {
                country_code: "IE",
                subdivision_name: "Louth",
                code: "IE-LH"
            },
            {
                country_code: "IE",
                subdivision_name: "Mayo",
                code: "IE-MO"
            },
            {
                country_code: "IE",
                subdivision_name: "Meath",
                code: "IE-MH"
            },
            {
                country_code: "IE",
                subdivision_name: "Monaghan",
                code: "IE-MN"
            },
            {
                country_code: "IE",
                subdivision_name: "Offaly",
                code: "IE-OY"
            },
            {
                country_code: "IE",
                subdivision_name: "Roscommon",
                code: "IE-RN"
            },
            {
                country_code: "IE",
                subdivision_name: "Sligo",
                code: "IE-SO"
            },
            {
                country_code: "IE",
                subdivision_name: "Tipperary",
                code: "IE-TA"
            },
            {
                country_code: "IE",
                subdivision_name: "Waterford",
                code: "IE-WD"
            },
            {
                country_code: "IE",
                subdivision_name: "Westmeath",
                code: "IE-WH"
            },
            {
                country_code: "IE",
                subdivision_name: "Wexford",
                code: "IE-WX"
            },
            {
                country_code: "IE",
                subdivision_name: "Wicklow",
                code: "IE-WW"
            }
        ],
        currency: 'EUR'
    },
    PL: {
        country_code: 'PL',
        name: 'Poland',
        timezones: ['Europe/Warsaw'],
        preDial: '+48',
        nationalPreDial: '0',
        internationalPreDial: '00',
        mobilePreDials: [
            '50',
            '45',
            '51',
            '53',
            '57',
            '60',
            '66',
            '69',
            '72',
            '73',
            '78',
            '79',
            '88'
        ],
        subregions: [
            {
                country_code: "PL",
                subdivision_name: "Dolnoslaskie",
                code: "PL-02"
            },
            {
                country_code: "PL",
                subdivision_name: "Kujawsko-pomorskie",
                code: "PL-04"
            },
            {
                country_code: "PL",
                subdivision_name: "Lodzkie",
                code: "PL-10"
            },
            {
                country_code: "PL",
                subdivision_name: "Lubelskie",
                code: "PL-06"
            },
            {
                country_code: "PL",
                subdivision_name: "Lubuskie",
                code: "PL-08"
            },
            {
                country_code: "PL",
                subdivision_name: "Malopolskie",
                code: "PL-12"
            },
            {
                country_code: "PL",
                subdivision_name: "Mazowieckie",
                code: "PL-14"
            },
            {
                country_code: "PL",
                subdivision_name: "Opolskie",
                code: "PL-16"
            },
            {
                country_code: "PL",
                subdivision_name: "Podkarpackie",
                code: "PL-18"
            },
            {
                country_code: "PL",
                subdivision_name: "Podlaskie",
                code: "PL-20"
            },
            {
                country_code: "PL",
                subdivision_name: "Pomorskie",
                code: "PL-22"
            },
            {
                country_code: "PL",
                subdivision_name: "Slaskie",
                code: "PL-24"
            },
            {
                country_code: "PL",
                subdivision_name: "Swietokrzyskie",
                code: "PL-26"
            },
            {
                country_code: "PL",
                subdivision_name: "Warminsko-mazurskie",
                code: "PL-28"
            },
            {
                country_code: "PL",
                subdivision_name: "Wielkopolskie",
                code: "PL-30"
            },
            {
                country_code: "PL",
                subdivision_name: "Zachodniopomorskie",
                code: "PL-32"
            }
        ],
        currency: 'PLN'
    },
    US: {
        country_code: 'US',
        name: 'United States of America',
        timezones: ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles'],
        preDial: '+1',
        nationalPreDial: '1',
        internationalPreDial: '011',
        mobilePreDials: [],
        subregions: [
            {
                country_code: "US",
                subdivision_name: "Alabama",
                code: "US-AL"
            },
            {
                country_code: "US",
                subdivision_name: "Alaska",
                code: "US-AK"
            },
            {
                country_code: "US",
                subdivision_name: "Arizona",
                code: "US-AZ"
            },
            {
                country_code: "US",
                subdivision_name: "Arkansas",
                code: "US-AR"
            },
            {
                country_code: "US",
                subdivision_name: "California",
                code: "US-CA"
            },
            {
                country_code: "US",
                subdivision_name: "Colorado",
                code: "US-CO"
            },
            {
                country_code: "US",
                subdivision_name: "Connecticut",
                code: "US-CT"
            },
            {
                country_code: "US",
                subdivision_name: "Delaware",
                code: "US-DE"
            },
            {
                country_code: "US",
                subdivision_name: "District of Columbia",
                code: "US-DC"
            },
            {
                country_code: "US",
                subdivision_name: "Florida",
                code: "US-FL"
            },
            {
                country_code: "US",
                subdivision_name: "Georgia",
                code: "US-GA"
            },
            {
                country_code: "US",
                subdivision_name: "Hawaii",
                code: "US-HI"
            },
            {
                country_code: "US",
                subdivision_name: "Idaho",
                code: "US-ID"
            },
            {
                country_code: "US",
                subdivision_name: "Illinois",
                code: "US-IL"
            },
            {
                country_code: "US",
                subdivision_name: "Indiana",
                code: "US-IN"
            },
            {
                country_code: "US",
                subdivision_name: "Iowa",
                code: "US-IA"
            },
            {
                country_code: "US",
                subdivision_name: "Kansas",
                code: "US-KS"
            },
            {
                country_code: "US",
                subdivision_name: "Kentucky",
                code: "US-KY"
            },
            {
                country_code: "US",
                subdivision_name: "Louisiana",
                code: "US-LA"
            },
            {
                country_code: "US",
                subdivision_name: "Maine",
                code: "US-ME"
            },
            {
                country_code: "US",
                subdivision_name: "Maryland",
                code: "US-MD"
            },
            {
                country_code: "US",
                subdivision_name: "Massachusetts",
                code: "US-MA"
            },
            {
                country_code: "US",
                subdivision_name: "Michigan",
                code: "US-MI"
            },
            {
                country_code: "US",
                subdivision_name: "Minnesota",
                code: "US-MN"
            },
            {
                country_code: "US",
                subdivision_name: "Mississippi",
                code: "US-MS"
            },
            {
                country_code: "US",
                subdivision_name: "Missouri",
                code: "US-MO"
            },
            {
                country_code: "US",
                subdivision_name: "Montana",
                code: "US-MT"
            },
            {
                country_code: "US",
                subdivision_name: "Nebraska",
                code: "US-NE"
            },
            {
                country_code: "US",
                subdivision_name: "Nevada",
                code: "US-NV"
            },
            {
                country_code: "US",
                subdivision_name: "New Hampshire",
                code: "US-NH"
            },
            {
                country_code: "US",
                subdivision_name: "New Jersey",
                code: "US-NJ"
            },
            {
                country_code: "US",
                subdivision_name: "New Mexico",
                code: "US-NM"
            },
            {
                country_code: "US",
                subdivision_name: "New York",
                code: "US-NY"
            },
            {
                country_code: "US",
                subdivision_name: "North Carolina",
                code: "US-NC"
            },
            {
                country_code: "US",
                subdivision_name: "North Dakota",
                code: "US-ND"
            },
            {
                country_code: "US",
                subdivision_name: "Ohio",
                code: "US-OH"
            },
            {
                country_code: "US",
                subdivision_name: "Oklahoma",
                code: "US-OK"
            },
            {
                country_code: "US",
                subdivision_name: "Oregon",
                code: "US-OR"
            },
            {
                country_code: "US",
                subdivision_name: "Pennsylvania",
                code: "US-PA"
            },
            {
                country_code: "US",
                subdivision_name: "Rhode Island",
                code: "US-RI"
            },
            {
                country_code: "US",
                subdivision_name: "South Carolina",
                code: "US-SC"
            },
            {
                country_code: "US",
                subdivision_name: "South Dakota",
                code: "US-SD"
            },
            {
                country_code: "US",
                subdivision_name: "Tennessee",
                code: "US-TN"
            },
            {
                country_code: "US",
                subdivision_name: "Texas",
                code: "US-TX"
            },
            {
                country_code: "US",
                subdivision_name: "Utah",
                code: "US-UT"
            },
            {
                country_code: "US",
                subdivision_name: "Vermont",
                code: "US-VT"
            },
            {
                country_code: "US",
                subdivision_name: "Virginia",
                code: "US-VA"
            },
            {
                country_code: "US",
                subdivision_name: "Washington",
                code: "US-WA"
            },
            {
                country_code: "US",
                subdivision_name: "West Virginia",
                code: "US-WV"
            },
            {
                country_code: "US",
                subdivision_name: "Wisconsin",
                code: "US-WI"
            },
            {
                country_code: "US",
                subdivision_name: "Wyoming",
                code: "US-WY"
            }
        ],
        currency: 'USD'
    }
};
exports.MAP_REGIONID_2_SUBREGION = {
    79: 'AT-1',
    81: 'CH-AG',
    95: 'CH-AR',
    96: 'CH-AI',
    97: 'CH-BL',
    98: 'CH-BS',
    80: 'CH-BE',
    99: 'CH-FR',
    100: 'CH-GE',
    94: 'CH-GL',
    87: 'CH-GR',
    84: 'CH-JU',
    89: 'CH-LU',
    101: 'CH-NE',
    90: 'CH-NW',
    102: 'CH-OW',
    103: 'CH-SH',
    86: 'CH-SZ',
    104: 'CH-SO',
    105: 'CH-SG',
    88: 'CH-TI',
    82: 'CH-TG',
    85: 'CH-UR',
    83: 'CH-VD',
    92: 'CH-VS',
    91: 'CH-ZG',
    93: 'CH-ZH',
    63: 'DE-BW',
    64: 'DE-BY',
    65: 'DE-BE',
    66: 'DE-BB',
    67: 'DE-HB',
    68: 'DE-HH',
    69: 'DE-HE',
    70: 'DE-MV',
    71: 'DE-NI',
    72: 'DE-NW',
    73: 'DE-RP',
    74: 'DE-SL',
    75: 'DE-SN',
    76: 'DE-ST',
    77: 'DE-SH',
    78: 'DE-TH',
    106: 'LI-01',
    107: 'LU-LU'
};
